// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jy-0";
export var buttonContainer = "_jy-3";
export var cancelButton = "_jy-4";
export var headerSection = "_jy-6";
export var headerTitle = "_jy-9";
export var messageSideLeft = "_jy-1";
export var messageSideRight = "_jy-2";
export var orderNumberContainer = "_jy-7";
export var orderNumberLabel = "_jy-8";
export var submitButton = "_jy-5";